import { css, keyframes } from '@emotion/react';

const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

export const fadeInAnimation = css`
  animation: ${fadeIn} 0.4s ease-in;

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;

const slideIn = keyframes`
  from { transform: translateX(100%); }
  to { transform: translateX(0); }
`;

export const slideInAnimation = css`
  animation: ${slideIn} 0.3s ease-in;

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;
